var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEditIcon = function SvgEditIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 25"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipPath: "url(#editIcon_svg__a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.271 19.562 3.534 3.532L2.178 24a.546.546 0 0 1-.667-.636l.76-3.803Zm.485-1.059 4.151 4.15L20.043 9.52l-4.072-4.07L2.756 18.502ZM20.815 8.75l-4.068-4.068L19.98 1.49a1.637 1.637 0 0 1 2.307.007L24.02 3.23a1.636 1.636 0 0 1 0 2.313z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "editIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.614.518h24v24h-24z"
  })))));
};
export { SvgEditIcon as ReactComponent };